import { useState } from 'react';
import { ContentCategoryClient, ContentCategoryDTO, ApiResponse_string, SearchRequestDTO_ContentCategorySearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

export const useContentCategoryApi = () => {
    const apiClient = new ContentCategoryClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ContentCategoryDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createContentCategory(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ContentCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ContentCategoryDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateContentCategory(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ContentCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getContentCategoryById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ContentCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchContentCategories(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ContentCategories');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteContentCategory(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ContentCategory');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportContentCategories(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting ContentCategories', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};